import { Paper, Stack, Typography } from '@mui/material'
import { RosterType } from '__generated__/graphql'
import React from 'react'
import RosterAccessIndicator from 'shared/components/RosterAccessIndicator'
import { getPxAsRem } from 'shared/utils'
import RosterTypePill from './RosterTypePill'

export interface MappingHeaderProps {
    rosterName: string
    subtitle: string
    showTypePill?: boolean
    actionButtons?: React.ReactNode
    canEdit?: boolean
    showPermissionsIndicator: boolean
}

const MappingHeader: React.FC<MappingHeaderProps> = ({
    rosterName,
    subtitle,
    showTypePill = false,
    actionButtons = null,
    canEdit = false,
    showPermissionsIndicator,
}) => {
    return (
        <Stack
            component={Paper}
            borderRadius={getPxAsRem(3, 8)}
            padding={getPxAsRem(24, 24)}
            direction="row"
            width="100%"
            display={'flex'}
            minWidth={getPxAsRem(350)}
            spacing={3}
            height={getPxAsRem(100)}
            justifyContent={'space-between'}
            position={'relative'}
        >
            <Stack direction="column">
                <Stack direction={'row'} spacing={1.5} alignItems={'center'}>
                    <Typography variant={'h3'}>{rosterName}</Typography>
                    {showTypePill && (
                        <RosterTypePill rosterType={RosterType.Mapping} />
                    )}
                    {showPermissionsIndicator && (
                        <RosterAccessIndicator isLocked={!canEdit} />
                    )}
                </Stack>
                <Typography variant="subtitle1" color="textSecondary">
                    {subtitle}
                </Typography>
            </Stack>
            {actionButtons}
        </Stack>
    )
}

export default MappingHeader
